import React from 'react';

// Status filter — inactive users are hidden by default.
export const STATUS_OPTIONS = [
    { label: 'Activos', value: 'active' },
    { label: 'Inactivos', value: 'inactive' },
    { label: 'Todos', value: 'all' }
];

/** Name search + status filter for the users table. Writes the visible rows through `setRows`. */
export function useUserFilters({ users, setRows }) {
    const [suggestions, setSuggestions] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState('');
    const [status, setStatus] = React.useState('active');

    const applyFilters = React.useCallback(
        (search, statusFilter) => {
            let filtered = users || [];
            if (statusFilter === 'active') filtered = filtered.filter((u) => u.active !== false);
            else if (statusFilter === 'inactive') filtered = filtered.filter((u) => u.active === false);

            const term = (search || '').trim().toLowerCase();
            if (term) filtered = filtered.filter((u) => u.name && u.name.toLowerCase().includes(term));

            setRows(filtered);
            return filtered;
        },
        [users, setRows]
    );

    // Apply the default (Activos) filter on load and whenever the user list is refreshed.
    React.useEffect(() => {
        applyFilters(searchValue, status);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users]);

    const onSearch = (search) => {
        try {
            setSearchValue(search);
            const filtered = applyFilters(search, status);
            const term = (search || '').trim();
            setSuggestions(term ? filtered.map((c) => c.name) : []);
        } catch (error) {
            console.warn('Error in user search:', error);
            setSuggestions([]);
        }
    };

    const onStatusChange = (value) => {
        setStatus(value);
        applyFilters(searchValue, value);
    };

    return { suggestions, searchValue, setSearchValue, status, onSearch, onStatusChange };
}
